import React, { useState, useEffect, useContext } from "react";
import { isMobile } from 'react-device-detect';
import ModelContext from "../ModelContext";
import useMediaQuery from '@mui/material/useMediaQuery';

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import "./generalarrangement-styles.css";

export const GeneralArrangements = (props) => {
    const isMobile = useMediaQuery('(max-width:480px)');
    const isTablet = useMediaQuery('(max-width:1024px)'); 

    const isVertical = (isMobile || isTablet);

    const modelCtx = useContext(ModelContext);

    const [layouts, setLayouts] = useState([{
        filename: "",
        flaG_FG: false,
        flaG_FGA: false,
        fullpatH_FILE_NAME: "",
        layouT_GROUP_ID: 0,
        layouT_GROUP_LANGUAGES_DESCRIPTION: "",
        layouT_MAPPING: "",
        tags: "",
        tagS_DESCRIPTION: "",
        templateS_DESCRIPTION: "",
        updatE_DATE: ""
    }]);

    useEffect(() => {

        const getLayouts = async () => {
            const input = modelCtx.inputModelData;
            if (input.idBasicModel !== 0 && input.idModel !== 0) {
                const response = await fetch("/api/model/layout", {
                    method: 'POST',
                    body: JSON.stringify(input),
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data) {
                        setLayouts(data);
                    }
                } else {
                    // Error
                }
            }
        }
        getLayouts();



    }, [modelCtx.inputModelData]);


    return (
        <>
            <div className="row">
                <div className="col-12 bg-blue descriptions">
                    <div className="box">
                        <p className="color-white wow fadeInUp" data-wow-delay="0.4s">
                            <span className="title1">General <br />arrangements</span>
                        </p>
                        <br /><br />
                    </div>
                </div>
            </div>
            <div className="row pb-5">
                <div className="clear"></div>
            </div>
            <div className="row">
                {!isVertical &&
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                    >

                        {layouts.map((lay, i) => (
                            <SwiperSlide key={i}>
                                <img src={lay.filename}
                                    alt={lay.tagS_DESCRIPTION} className="generalarrangements-layout-width" /><br />
                                <p className="text4 text-center">{lay.tagS_DESCRIPTION}</p>
                            </SwiperSlide>
                        ))}

                    </Swiper>
                }

                {isVertical &&
                    <div className="row">
                        <div className="col-12">
                            {layouts.map((lay, i) => (
                                <span key={i}>
                                    <img src={lay.filename}
                                        alt={lay.tagS_DESCRIPTION} className="generalarrangements-layout-width" /><br />
                                    <p className="text4 text-center">{lay.tagS_DESCRIPTION}</p>
                                </span>
                            ))}
                        </div>
                    </div>
                }
            </div>
            <div className="row pb-5">
                <div className="clear"></div>
            </div>
            <div className="row pb-5">
                <div className="clear"></div>
            </div>
        </>
    );
};

export default GeneralArrangements;
